export default "__VITE_ASSET__bfdf1c61__"